import { render } from "./identification-infos.vue?vue&type=template&id=4580fb05&scoped=true"
import script from "./identification-infos.vue?vue&type=script&lang=js"
export * from "./identification-infos.vue?vue&type=script&lang=js"

import "./identification-infos.vue?vue&type=style&index=0&id=4580fb05&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4580fb05"]])

export default __exports__